import { useTranslation } from "react-i18next"
import { Warning } from "@phosphor-icons/react"

const SearchError = () => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center px-2 py-1">
      <span className="mr-2 shrink-0">
        <Warning size={24} className="text-critical" />
      </span>
      <p className="flex flex-col">
        <span className="text-on-surface text-sm leading-5">{t("patient.medication.searchFailed")}</span>
        <span className="text-on-surface-subdued text-xs leading-4 tracking-[0.25px]">
          {t("patient.medication.contactTBD")}
        </span>
      </p>
    </div>
  )
}

export { SearchError }
